export enum WebsocketEventTypes {
  REQUEST = 'request',
  MESSAGE = 'message',
  CLOSE = 'close',
  ERROR = 'error',
  OPEN = 'open',
  PING = 'ping',
}
